<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        星汉未来咨询服务
      </a-typography-title>
      <a-typography-paragraph>
        {{
          '基于多年来在互联网行业积累的最佳实践经验及方法论，星汉未来技术专家为企业用户提供IT成本管理及Serveress架构升级方案咨询。' +
          '通过最佳实践参考和理论指引，搭配星汉未来提供的配套工具及持续性保障，帮助企业云上业务实现持续高质量发展。'
        }}
      </a-typography-paragraph>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="$Store.Page().openModal('modalOperate','reserve')">
          咨询详情
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'consult_banner'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/consult/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 150px 0 80px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

div.ant-typography {
  max-width: 500px;
  margin: 20px 0 0;
  .font(justify, @text+@line, @color_white, @text);
}

.ant-space {
  margin: 20px 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>